const game = {

	app: null,


	/**
	 * Constants for the game modes.
	 *
	 * @type {int}
	 */
	MODE_MENU: 1,
	MODE_PLAY: 2,
	MODE_FINISH: 3,
	MODE_COUNTDOWN: 4,


	/**
	 * Length of game in seconds for development.
	 * In production this is set to 60 seconds.
	 *
	 * @type {int}
	 */
	gameLength: 5,


	/**
	 * Update frequency in milliseconds.
	 *
	 * @type {int}
	 */
	gameTimeUpdate: 50,


	init: function() {

		if ( game.app ) {
			return;
		}

		const $comp = document.querySelector( '#game-container' );

		game.app = new Reef(
			$comp,
			{
				data: {
					flag: '', // The flag to display (and the correct answer).
					answers: [], // The possible answers (including the correct answer).
					correct: 0, // How many questions have been answered correctly.
					asked: 0, // How many questions have been asked.
					mode: game.MODE_MENU,
					timeRemaining: game.gameLength,
					answered: [],
				},
				template: game.template,
			}
		);

		$comp.addEventListener( 'click', game.click );

		game.continents = game.getContinents();
		console.log( game.continents );

		game.app.render();

		// If url contains brush.ninja set the gameLength to 60 seconds.
		if ( window.location.href.indexOf( 'brush.ninja' ) > -1 ) {
			game.gameLength = 60;
		}


	},


	/**
	 * Get a list of continents.
	 *
	 * @return {array} The list of continents.
	 */
	getContinents: function() {

		// Loop through country_codes
		const continents = [];
		Object.keys( country_codes ).forEach(
			( key ) => {
				continents.push( country_codes[ key ][ 1 ] );
			}
		);
		// Make continents unique.
		return continents.filter( ( value, index, self ) => self.indexOf( value ) === index );

	},


	/**
	 * Get a random country.
	 *
	 * @return {object} The country code and name.
	 */
	randomCountry: function() {

		const keys = Object.keys( country_codes );
		const randomId = Math.floor( Math.random() * keys.length );
		return {
			code: keys[ randomId ],
			name: country_codes[ keys[ randomId ] ],
		};

	},


	/**
	 * Start the countdown timer.
	 *
	 * @return {void}
	 */
	startCountdown: function() {

		game.app.setData(
			{
				timeRemaining: game.gameLength,
			}
		);

		setTimeout( game.updateCountdown, game.gameTimeUpdate );

	},


	/**
	 * Explode confetti.
	 *
	 * @param {string} id The element to target.
	 * @return {void}
	 */
	explode: function( id ) {

		confetti(
			{
				particleCount: 60,
				spread: 360,
				ticks: 70,
				origin: { y: 0.45 },
				gravity: 0.75,
				startVelocity: 30,
				scalar: 1.75,
				disableForReducedMotion: true,
			}
		);

	},


	/**
	 * Update the intro countdown timer.
	 *
	 * @return {void}
	 */
	updateCountdown: function() {

		const data = game.app.data;
		let timeRemaining = data.timeRemaining - ( game.gameTimeUpdate / 1000 );

		if ( timeRemaining <= 0 ) {

			game.app.setData(
				{
					mode: game.MODE_FINISH
				}
			);
			return;

		}

		setTimeout( game.updateCountdown, game.gameTimeUpdate );

		game.app.setData(
			{
				timeRemaining: timeRemaining,
			}
		);

	},


	/**
	 * The template for the app.
	 *
	 * @param {object} props The data for the app.
	 * @return {string} The HTML for the app.
	 */
	template: function( props ) {

		switch ( props.mode ) {
			case game.MODE_MENU:
				return game.templateMenu( props );

			case game.MODE_PLAY:
				return game.templateGame( props );

			case game.MODE_FINISH:
				return game.templateFinish( props );

			case game.MODE_COUNTDOWN:
				return game.templateCountdown( props );

		}

	},


	/**
	 * The template for the main menu.
	 *
	 * @param {object} props The app properties.
	 * @return {string}
	 */
	templateMenu: function( props ) {

		return `
			<h1 class="m-b4">Fun with Flags</h1>
			<button
				class="button jumbo"
				data-action="play"
			>Play</button>
		`;

	},


	/**
	 * The template for the game.
	 *
	 * @param {object} props The data for the app.
	 * @return {string} The HTML for the app.
	 */
	templateGame: function( props ) {

		const buttonClass = 'bg-white p2 b-br1 w100 f-fw900 f5 h100 m0';
		const percentCompleted = 1 - props.timeRemaining / game.gameLength;

		return `
			<div class="f3 fg-blue-dark f-fw900 m-b3 flex flex-center gap3">
				<progress min="0" max="100" value="${percentCompleted * 100}"></progress>
				${Math.ceil( props.timeRemaining )}
			</div>
			<strong class="display-block t-ta-c m-b3">Which country has this flag?</strong>
			<div class="m-y4" style="font-size: 250px; line-height: 1; text-shadow: 0 0 150px yellow;">${game.getFlagEmoji( props.flag.code )}</div>
			<div class="flex flex-col d:flex-row flex-ai-stretch gap2 m-t4 d:h4">
				<button data-action="answer" data-value="${props.answers[ 0 ].code}" class="${buttonClass}">${props.answers[ 0 ].name[ 0 ]}</button>
				<button data-action="answer" data-value="${props.answers[ 1 ].code}" class="${buttonClass}">${props.answers[ 1 ].name[ 0 ]}</button>
				<button data-action="answer" data-value="${props.answers[ 2 ].code}" class="${buttonClass}">${props.answers[ 2 ].name[ 0 ]}</button>
			</div>
		`;

	},


	/**
	 * The game over and stats screen.
	 *
	 * @param {object} props The data for the app.
	 * @return {string} The HTML for the app.
	 */
	templateFinish: function() {

		const percentage = Math.round( ( game.app.data.correct / game.app.data.answered.length ) * 100 );

		let message = 'Game Over 🙁';

		if ( percentage >= 25 ) {
			message = 'Good Effort';
		}

		if ( percentage >= 50 ) {
			message = 'Well Done! 😊';
		}

		if ( percentage >= 75 ) {
			message = 'Amazing! 😄';
		}

		if ( percentage >= 95 ) {
			message = 'Perfect! 😍';
		}

		return `
			<h2 class="f-fw900 f1 m-b3">${message}</h2>
			<div class="f-fw900 m-b3 flex flex-center gap4 o50 t-tt-u">
				<span>${game.app.data.answered.length} Asked</span>
				<span>${game.app.data.correct} Correct</span>
			</div>
			<span class="display-block f-fw900 f3 m-y4">${percentage}% Accuracy</span>
			<button class="button jumbo m-b5" data-action="menu">Menu</button>
			<h3>Your Answers</h3>
			<div class="mw6 m-auto">${game.templateAnswers( game.app.data.answered )}</div>
		`;

	},


	/**
	 * Display a list of the answers and if the player got them right or wrong.
	 *
	 * @param {object} answers The answers.
	 * @return {string} The HTML for the answers.
	 */
	templateAnswers: function( answers ) {

		let html = '';

		// Loop through answers array.
		for ( let i = 0; i < answers.length; i++ ) {

			let answer = answers[ i ];
			let icon = '❌';
			// If the answer is correct, add a class.
			if ( answer.correct ) {
				icon = '✅';
			}

			html += `
			<div class="bg-white p3 b-br1 m-b2 flex flex-ai-c gap3 f5">
				<span>${icon}</span>
				<div style="font-size: 60px; line-height: 0.7;">${game.getFlagEmoji( answer.code, 'w2' )}</div>
				<div class="t-ta-l f-fw900">${answer.name[ 0 ]} [${answer.name[ 1 ]}]</div>
			</div>`;

		}

		if ( answers.length === 0 ) {
			html = `<p class="f4 f-fw900 bg-green b-br2 p3">No answers 😢</p>`;
		}

		return html;

	},


	/**
	 * Get a flag emoji from a country code.
	 *
	 * @param {string} countryCode The country code.
	 * @return {string} The flag emoji.
	 */
	getFlagEmoji: function( countryCode, size = 'w5' ) {

		const image = `/assets/images-flags/${countryCode.toLowerCase()}.png`;
		return `<img src="${image}" alt="${countryCode}" class="${size} m-auto">`;

		// const codePoints = countryCode
		// 	.toUpperCase()
		// 	.split( '' )
		// 	.map( char => 127397 + char.charCodeAt() );
		// return String.fromCodePoint( ...codePoints );

	},



	/**
	 * Load the next question.
	 *
	 * @return {void}
	 */
	nextQuestion: function() {

		const correct = game.randomCountry(); // Pick a random country.
		const answers = [
			correct,
			game.randomCountry(),
			game.randomCountry()
		].sort( () => 0.5 - Math.random() );

		game.app.setData(
			{
				asked: game.app.data.asked + 1,
				flag: correct,
				answers: answers,
			}
		);

	},


	/**
	 * Reset the game.
	 *
	 * @return {void}
	 */
	resetGame: function() {

		game.app.setData(
			{
				asked: 0,
				correct: 0,
				answered: [],
			}
		);

	},


	/**
	 * Click event.
	 *
	 * @param {event} e The click event.
	 * @return {void}
	 */
	click: function( e ) {

		const target = e.target;
		const action = target.getAttribute( 'data-action' );

		if ( action ) {
			e.preventDefault();
		}

		console.log( action );

		// Start the game.
		if ( 'play' === action ) {

			game.resetGame();
			game.nextQuestion();
			game.startCountdown();

			game.app.setData(
				{
					mode: game.MODE_PLAY,
				}
			);

			return;

		}

		// Go to menu.
		if ( 'menu' === action ) {

			game.app.setData(
				{
					mode: game.MODE_MENU,
				}
			);
			return;

		}

		// Answer the question.
		if ( 'answer' === action ) {

			// See if there's an answer. This will be empty if anything other than a button is clicked.
			const answer = target.getAttribute( 'data-value' );

			const data = game.app.data;

			const currentQuestion = data.flag;
			currentQuestion.correct = false;

			// Is the answer correct?
			if ( answer === data.flag.code ) {
				// Yes, add a point.
				data.correct++;
				currentQuestion.correct = true;
				game.explode( 'theFlag' );
			}

			const answered = data.answered;
			answered.push( currentQuestion );

			game.app.setData(
				{
					answered: answered,
				}
			);

			// Load the next question.
			game.nextQuestion();

		}

	}

};



; (
	function() {

		'use strict';

		ready(

			function() {

				game.init();

			}

		);

	}
)();
